<script lang="ts">
	import { trackEvent } from '$lib/segment/client';
	import Gift from '../icons/gift.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
</script>

<div class="relative z-20 flex w-full items-center justify-center bg-green-3 py-3">
	<Button
		class="btn-large font-semibold"
		style="--bg-color: rgb(10, 103, 70); --hover-bg-color: rgb(32, 73, 62)"
		onclick={() => trackEvent('Show friendbuy')}
		><span>Get your <span class="text-green-5">referral reward</span></span><Gift
			class="text-green-5"
		/></Button
	>
</div>
